import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import axiosInstance from "../../../api/axiosInstance";
import { baseurImage } from "../../../Baseurl";
import logo1 from "../../../assests/logo.png";
export default function Dentalprescription() {
  const navigate = useNavigate();
  const [patients1, setPatients1] = useState([]);
  const [patie, setPatie] = useState({});
  const location = useLocation();
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [data, setData] = useState({});
  const pdfRef = useRef();
  const DrData = JSON.parse(localStorage.getItem("userMedical"));
  const DrData1 = localStorage.getItem("userName");
  const patientdata = location.state.datapatient;

  useEffect(() => {
    getdata1();
  }, []);
  const getdata1 = async () => {
    try {
      const response = await axiosInstance.get(
        `getPrescriptionById/${location.state.id}`
      );
      if (response.data.success) {
        const prescriptionData = response.data.data;

        // The API returns an array of medicine items directly
        // Each item is a medicine prescription with all fields at the top level
        setPatients1(prescriptionData);

        // Set patient info from the first item (all items have same patient data)
        if (prescriptionData.length > 0) {
          setPatie(prescriptionData[0]);
        }
      }
    } catch (error) {
      console.error("Error fetching patient data:", error.message);
      Swal.fire("Error", "Failed to fetch prescription data", "error");
    }
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEdit = (item) => {
    setEditData({ ...item });
    setEditModal(true);
  };

  const handleUpdate = async () => {
    try {
      const response = await axiosInstance.put(
        `updatePrescription/${editData.id}`,
        editData
      );
      if (response.data.success) {
        Swal.fire("Success", "Prescription updated successfully", "success");
        setEditModal(false);
        getdata1();
      } else {
        Swal.fire("Error", "Failed to update prescription", "error");
      }
    } catch (error) {
      console.error(error.message);
    }
  };
  const esponsedata = JSON.parse(localStorage.getItem("userMedical"));
  useEffect(() => {
    gethospitaldetails();
  }, []);

  const businessSetting = JSON.parse(localStorage.getItem("businessSetting"));
  const businessAddress = businessSetting?.address || "N/A";
  const businessCR = businessSetting?.cr_number || "N/A";
  const businessVAT = businessSetting?.vat_number || "";



  const phone = businessSetting?.telephone_1 || 'N/A';
  const hospitalName = businessSetting?.official_name || 'N/A';
  const email = businessSetting?.email || 'N/A';
  const website = businessSetting?.website;

  const gethospitaldetails = async () => {
    try {
      const response = await axiosInstance.get(
        `getBusinessSettingByDoctorId/${esponsedata.data.id}`
      );
      setData(response.data.data);
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  const downloadPDF = () => {
    if (!pdfRef.current) {
      console.error("pdfRef is undefined!");
      return;
    }
    const content = pdfRef.current.innerHTML;
    const fileName = `Prescription_${patie?.patientName || "Patient"}`;
    const printWindow = window.open("", "_blank");
    printWindow.document.open();
    printWindow.document.write(`
<html>
  <head>
    <title>${fileName}</title>
    <style>
      body {
        font-family: Arial, sans-serif;
        line-height: 1.2;
        background: #fff;
      }

      /* -------- CENTERING FIX -------- */
      .main-wrapper {
        width: 210mm;          /* A4 width */
        margin: 0 auto;        /* Center horizontally */
        background: #fff;
      }

      @page { size: A4; margin: 5mm; }

      table { width: 100%; border-collapse: collapse; margin-top: 20px; }
      td, th { border: 1px solid #000; padding: 3px 10px; text-align: left; }
        .footer {
        position: fixed;
        bottom: 0mm;
        width: 100%;
        text-align: center;
        font-size: 12px;
        padding: 5px 0;
      }
    </style>
  </head>

  <body>
    <div class="main-wrapper">
      ${content}
    </div>

    <div class="footer">
      <div style="margin-top: 190px; font-size: 12px; text-align: center; color: rgb(0, 0, 0);">
        Hospital Name: ${hospitalName} | Email: 
        <span style="border-bottom: 1px solid rgb(44, 100, 223); color: rgb(44, 100, 223);">
          ${email}
        </span> 
        | Phone: ${phone} | 
        <span style="border-bottom: 1px solid rgb(44, 100, 223); color: rgb(44, 100, 223);">
          Website: ${website}
        </span>
      </div>
    </div>

    <script>
      function addPageNumbers() {
        const pageHeight = 1122;
        const totalPages = Math.ceil(document.body.scrollHeight / pageHeight);

        for (let i = 1; i <= totalPages; i++) {
          const div = document.createElement('div');
          div.style.position = 'absolute';
          div.style.top = (i - 1) * pageHeight + 10 + 'px';
          div.style.right = '10px';
          div.style.fontSize = '12px';
          div.innerText = 'Page ' + i + ' of ' + totalPages;
          document.body.appendChild(div);
        }
      }

      window.onload = function() {
        addPageNumbers();
        window.focus();
        window.print();
      };
    </script>

  </body>
</html>
`);

    printWindow.document.close();
  };

  return (
    <div className="pc-container">
      <div className="pc-content">
        {/* HEADER BUTTONS */}

        <div className="d-flex justify-content-between align-items-center mb-3">
          <button
            className="bgBtn rounded-pill px-3"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>

          <button className="bgBtn rounded-pill px-3" onClick={downloadPDF}>
            Print / Download PDF
          </button>
        </div>

        {/* pdf content */}
        <div
          ref={pdfRef}
          className="prePdf"
          style={{
            background: "#fff",
          }}
        >
          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              <img
                src={data?.image ? `${baseurImage}${data.image}` : logo1}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = logo1;
                }}
                alt="Logo"
                style={{ height: "80px" }}
              />
            </div>

            <h2
              style={{
                marginTop: "30px",
                fontWeight: "700",
                marginBottom: "0px",
              }}
            >
              {data?.official_name}
            </h2>
            <p style={{ margin: 0 }}>
              <strong>Address : </strong> {businessAddress}
            </p>
            <p style={{ margin: 0 }}>
              <strong>CR:</strong> {businessCR}
            </p>
            <p style={{ margin: 0 }}>
              <strong>VAT No.</strong> {businessVAT}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
              borderTop: "1px solid #000",
            }}
          >
            <div style={{ marginTop: "50px" }}>
              <p style={{ margin: 0 }}>
                <strong>Patient:</strong>  {patie.patient_name}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Gender:</strong> {patie.gender || "N/A"}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Age:</strong> {patie.age}
              </p>
              <p style={{ margin: 0 }}>
                <strong>CPR ID:</strong> {patie.civilIdNumber || "N/A"}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Phone:</strong> {patie.mobileNumber || "N/A"}
              </p>
            </div>

            <div style={{ marginTop: "50px" }}>
              <p style={{ margin: 0 }}>
                <strong>Doctor:</strong>{" "}
                {patie.doctorName}

              </p>
              <p style={{ margin: 0 }}>
                <strong>License:</strong> {patie.doctorLicenseId}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Date:</strong>{" "}
                {new Date(patie.created_at).toLocaleDateString("en-GB")}
              </p>
            </div>
          </div>
          <h1
            style={{
              borderTop: "1px solid #000",
              paddingTop: "30px",
              fontSize: "50px",
            }}
          >
            Rx
          </h1>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "80px",
            }}
          >
            <thead>
              <tr>
                <th>SR. NO.</th>
                <th>Medicine Name</th>
                <th>Substance</th>
                <th>Route</th>
                <th>Dosages</th>
                <th>Frequency</th>
                <th>Duration</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {patients1.length > 0 ? (
                patients1.map((med, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      {med.medicine_name} - {med.strength} - {med.dose}
                    </td>
                    <td>{med.substance}</td>
                    <td>{med.route}</td>
                    <td>{med.dosage}</td>
                    <td>{med.frequency}</td>
                    <td>{med.duration}</td>
                    <td>{med.notes}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">No Medicine Found</td>
                </tr>
              )}
            </tbody>

          </table>
          <div style={{ marginTop: "80px" }}>
            <p
              style={{
                paddingBottom: "80px",
                marginBottom: "20px",
                borderBottom: "1px solid #000",
                width: "230px",
              }}
            >
              <strong>Signature & Stamp:</strong>
            </p>
          </div>
        </div>
      </div>
      {editModal && (
        <div
          className="modal fade show"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "block",
          }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Prescription</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  {Object.keys(editData || {}).map((key) => (
                    <div key={key} className="col-6 mb-3">
                      <label className="form-label">{key}</label>
                      <input
                        className="form-control"
                        name={key}
                        value={editData[key]}
                        onChange={handleEditChange}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setEditModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handleUpdate}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
